import { useDispatch, useSelector } from 'react-redux'
import { openScreen, toggleMusic, toggleSound } from '@slices/uiSlice'
import Toggle from '@components/ui/Toggle'
import { soundManager } from '@core/audio/sounds/soundManager'
import {
  InfoSVG,
  JackpotPotSVG,
  MusicOffSVG,
  MusicOnSVG,
  MyBetsSVG,
  ShieldSVG,
  SoundsOffSVG,
  SoundsOnSVG,
  TournamentTrophySVG,
} from '@media/svgs'

const Menu = () => {
  const dispatch = useDispatch()

  const isMusicEnabled = useSelector((state) => state.ui.audio.music.enabled)
  const isSoundEnabled = useSelector((state) => state.ui.audio.sounds.enabled)
  const { jackpot, tournaments, freebets } = useSelector(
    (state) => state.configurations.featureToggles
  )

  const menuOptions = [
    {
      key: 'sounds',
      title: 'Sounds',
      type: 'toggle',
      icon: isSoundEnabled ? (
        <SoundsOnSVG width="18" height="18" />
      ) : (
        <SoundsOffSVG width="18" height="18" />
      ),
      checked: isSoundEnabled,
      onClick: () => dispatchMenuActions('sounds'),
      onCheck: () => dispatchMenuActions('sounds'),
      isEnabled: true,
    },
    {
      key: 'music',
      title: 'Music',
      type: 'toggle',
      icon: isMusicEnabled ? (
        <MusicOnSVG width="18" height="18" />
      ) : (
        <MusicOffSVG width="18" height="18" />
      ),
      checked: isMusicEnabled,
      onCheck: () => dispatchMenuActions('music'),
      isEnabled: true,
    },
    {
      key: 'myBets',
      title: 'My Bets',
      icon: <MyBetsSVG width="18" height="18" />,
      onCheck: () => dispatchMenuActions('myBets'),
      isEnabled: true,
    },
    {
      key: 'freebets',
      title: 'Freebets',
      // Stand-in icon (reuses the bonus-pot glyph) until a dedicated freebet
      // icon is added — swap the import/name here when one exists.
      icon: <JackpotPotSVG width="18" height="18" />,
      onCheck: () => dispatchMenuActions('freebets'),
      isEnabled: Boolean(freebets),
    },
    {
      key: 'tournaments',
      title: 'Tournaments',
      icon: <TournamentTrophySVG width="18" height="18" />,
      onClick: () => dispatchMenuActions('tournaments'),
      isEnabled: Boolean(tournaments),
    },
    {
      key: 'jackpot',
      title: 'Jackpot',
      icon: <JackpotPotSVG width="18" height="18" />,
      onClick: () => dispatchMenuActions('jackpot'),
      isEnabled: Boolean(jackpot),
    },
    {
      key: 'provablyFair',
      title: 'Provably Fair',
      icon: <ShieldSVG width="18" height="18" />,
      onCheck: () => dispatchMenuActions('provablyFair'),
      isEnabled: true,
    },
    {
      key: 'howToPlay',
      title: 'How to Play',
      icon: <InfoSVG width="18" height="18" />,
      onCheck: () => dispatchMenuActions('howToPlay'),
      isEnabled: true,
    },
  ]

  const dispatchMenuActions = (screen) => {
    soundManager.play('CLICK')
    switch (screen) {
      case 'sounds':
        dispatch(toggleSound())
        break
      case 'music':
        dispatch(toggleMusic())
        break
      case 'myBets':
        dispatch(
          openScreen({
            key: 'myBets',
            title: 'My Bets',
            screen: 'MY_BETS',
          })
        )
        break
      case 'freebets':
        dispatch(
          openScreen({
            key: 'freebets',
            title: 'Freebets',
            screen: 'FREEBETS',
          })
        )
        break
      case 'tournaments':
        dispatch(
          openScreen({
            key: 'tournaments',
            title: 'Tournaments',
            screen: 'TOURNAMENTS',
          })
        )
        break
      case 'jackpot':
        dispatch(
          openScreen({
            key: 'jackpot',
            title: 'Jackpot',
            screen: 'JACKPOT',
          })
        )
        break
      case 'provablyFair':
        dispatch(
          openScreen({
            key: 'provablyFair',
            title: 'Provably Fair',
            screen: 'PROVABLY_FAIR',
          })
        )
        break
      case 'howToPlay':
        dispatch(
          openScreen({
            key: 'howToPlay',
            title: 'How to Play',
            screen: 'HOW_TO_PLAY',
          })
        )
        break
      default:
        break
    }
  }

  return (
    <div className="standard-normal-menu-options-inner-container">
      {menuOptions
        .filter((opt) => opt.isEnabled)
        .map((opt) => (
          <div
            key={opt.key}
            className="standard-normal-menu-option"
            onClick={opt.onClick ?? opt.onCheck}
          >
            <div className="standard-normal-menu-option-icon">{opt.icon}</div>
            <div className="standard-normal-menu-option-title">{opt.title}</div>

            {opt.type === 'toggle' && (
              <div
                className="standard-normal-menu-option-toggle-box"
                onClick={(event) => event.stopPropagation()}
              >
                <Toggle isChecked={opt.checked} onCheck={opt.onCheck} />
              </div>
            )}
          </div>
        ))}
    </div>
  )
}

export default Menu
